module.exports = __webpack_public_path__ + "img/discord.05edf98b.jpg";